export default "__VITE_ASSET__Kf$tcboQ__"